import model from 'models/CourseModel';

export default Backbone.Collection.extend({
    model,
    comparator: 'name'
}, {
    type: 'courses'
})
